import lodash from "lodash";
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import {
  DIFFERENT_TO_OPERATOR,
  EQUAL_OPERATOR,
  GREATER_THAN_OPERATOR,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR,
  LESS_THAN_OPERATOR,
  LESS_THAN_OR_EQUALS_TO_OPERATOR
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";

Vue.use(Vuetify);
@Component({
  name: "FormRulePreview"
})
export default class FormRulePreview extends Vue {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  @Prop() private model!: any;
  @Prop() private formRules!: FormRule[];

  formTextSummary = "";
  rules: FormRule[] = [];

  FORM_RULES_TEXT = FORM_TEMP_CONSTANTS.RULE_LABEL.FORM_TEXT;

  mounted() {
    this.dataChanges();
  }

  @Watch("formRules", { deep: true })
  @Watch("model", { deep: true })
  dataChanges() {
    this.rules = [];
    this.formRules.forEach((rule: FormRule) => {
      if (this.condition(rule)) {
        this.rules.push(rule);
      }
    });
  }

  condition(rule: FormRule): boolean {
    if (rule.field === "") {
      return true;
    } else {
      if (!(rule.field in this.model)) {
        this.model[rule.field] = 0;
      }

      if (
        rule.field != undefined &&
        rule.ruleValue.value != undefined &&
        this.model
      ) {
        switch (rule.operator) {
          case EQUAL_OPERATOR.key:
            if (Array.isArray(rule.ruleValue.value)) {
              const modelArray = lodash.cloneDeep(this.model[rule.field]);
              const ruleArray = lodash.cloneDeep(rule.ruleValue.value);
              return (
                JSON.stringify(modelArray.sort()) ==
                JSON.stringify(ruleArray.sort())
              );
            } else {
              return this.model[rule.field] == rule.ruleValue.value;
            }
          case GREATER_THAN_OPERATOR.key:
            return this.model[rule.field] > rule.ruleValue.value;
          case GREATER_THAN_OR_EQUALS_TO_OPERATOR.key:
            return this.model[rule.field] >= rule.ruleValue.value;
          case LESS_THAN_OPERATOR.key:
            return this.model[rule.field] < rule.ruleValue.value;
          case LESS_THAN_OR_EQUALS_TO_OPERATOR.key:
            return this.model[rule.field] <= rule.ruleValue.value;
          case DIFFERENT_TO_OPERATOR.key:
            if (Array.isArray(rule.ruleValue.value)) {
              const modelArray = lodash.cloneDeep(this.model[rule.field]);
              const ruleArray = lodash.cloneDeep(rule.ruleValue.value);
              return (
                JSON.stringify(modelArray.sort()) !=
                JSON.stringify(ruleArray.sort())
              );
            } else {
              return this.model[rule.field] != rule.ruleValue.value;
            }
          default:
            return true;
        }
      }
      return false;
    }
  }
}
